// extracted by mini-css-extract-plugin
export var addButton = "_dd-0";
export var border = "_dd-8";
export var check = "_dd-h";
export var danger = "_dd-6";
export var dropdownContainer = "_dd-1";
export var editModalBody = "_dd-j";
export var footerContainer = "_dd-i";
export var fullWidth = "_dd-a";
export var hide = "_dd-9";
export var icon = "_dd-3";
export var input = "_dd-7";
export var inputFlex = "_dd-b";
export var inputWrapper = "_dd-c";
export var manualFocus = "_dd-5";
export var optionButton = "_dd-4";
export var pillWrapper = "_dd-e";
export var pointer = "_dd-2";
export var showOverflow = "_dd-f";
export var tagsFlex = "_dd-d";
export var xButton = "_dd-g";